import { render, staticRenderFns } from "./ManageUserScreen.vue?vue&type=template&id=2c2e37cc&scoped=true&"
import script from "./ManageUserScreen.vue?vue&type=script&lang=js&"
export * from "./ManageUserScreen.vue?vue&type=script&lang=js&"
import style0 from "./ManageUserScreen.vue?vue&type=style&index=0&id=2c2e37cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e37cc",
  null
  
)

component.options.__file = "ManageUserScreen.vue"
export default component.exports